const TickIconWithBorder = () => {
    return(
        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 29L27 39L43 19M29 57C25.323 57 21.682 56.2758 18.2849 54.8686C14.8877 53.4615 11.8011 51.399 9.20101 48.799C6.60097 46.1989 4.53851 43.1123 3.13137 39.7151C1.72424 36.318 1 32.677 1 29C1 25.323 1.72424 21.682 3.13137 18.2849C4.53851 14.8877 6.60097 11.8011 9.20101 9.20101C11.8011 6.60097 14.8877 4.5385 18.2849 3.13137C21.682 1.72424 25.323 1 29 1C36.4261 1 43.548 3.94999 48.799 9.20101C54.05 14.452 57 21.5739 57 29C57 36.4261 54.05 43.548 48.799 48.799C43.548 54.05 36.4261 57 29 57Z" stroke="#22C55E" stroke-width="2"/>
</svg>

    )
}

export default TickIconWithBorder